import { render, staticRenderFns } from "./UiDropdown.vue?vue&type=template&id=30701d54&"
import script from "./UiDropdown.vue?vue&type=script&lang=js&"
export * from "./UiDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UiDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports